import { render, staticRenderFns } from "./passwordreset.vue?vue&type=template&id=27a3a19a&scoped=true"
import script from "./passwordreset.vue?vue&type=script&lang=js"
export * from "./passwordreset.vue?vue&type=script&lang=js"
import style0 from "./passwordreset.vue?vue&type=style&index=0&id=27a3a19a&prod&lang=css"
import style1 from "./passwordreset.vue?vue&type=style&index=1&id=27a3a19a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a3a19a",
  null
  
)

export default component.exports